export const APP_CONSTANTS = {
  appName: 'TaskWombat',
  appVersion: '1.0.0',
  isMVPMode: true,
  flutterAppUrl: process.env.REACT_APP_FLUTTER_URL || 'https://app.taskwombat.com',
};

export const EMAIL_CONSTANTS = {
  serviceId: 'service_gf8ofeu',
  publicKey: 'k5PvmKvehIp0TvGr5',
  templateQuoteReceived: 'quote_received', // Updated from Flutter app constants
  templateContractorRegistration: 'contractor_registration', // Updated from Flutter app constants
  templateNewLeadNotification: 'new_lead_notification', // Template for notifying team about new leads
};

// Team member emails to notify when a new quote/lead is submitted
export const TEAM_NOTIFICATION_EMAILS = [
  'info.thiwangasri@gmail.com',
  'mukshith@gmail.com',
  'seraph.seankeish@gmail.com',
];

export const ROUTE_NAMES = {
  home: '/',
  features: '/features',
  howItWorks: '/how-it-works',
  services: '/services',
  commercialServices: '/commercial-services',
  contact: '/contact',
  blog: '/blog',
  quote: '/quote',
  contractorRegister: '/register/contractor',
  contractorRegisterEntry: '/register/contractor/entry',
  login: '/login',
  careers: '/careers',
  adminDashboard: '/admin/dashboard',
  adminQuotes: '/admin/quotes',
  adminQuoteDetails: '/admin/quotes/:id',
  adminContractorRequests: '/admin/contractor-requests',
  customerDashboard: '/customer/dashboard',
  contractorDashboard: '/contractor/dashboard',
};
